document.addEventListener('DOMContentLoaded', () => {
    let selector = "li#logout a";
    let logoutLink = document.querySelector(selector);

    if (logoutLink !== null) {
        $(selector).click(function (e) {
            e.preventDefault();
            if (confirm('Are you sure to logout?')) {
                window.location = logoutLink.href;
            }
        });
    }
});
